import { Component, OnInit } from '@angular/core';
import { CustomerBillingInvoiceModel } from '../customer-billing-invoice.model';
import { InvoiceService } from '../invoice.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { CustomerBillingInvoiceEditDialogComponent } from '../customer-billing-invoice-edit-dialog/customer-billing-invoice-edit-dialog.component';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { FiDialogCloseReason } from '@fi-shared/fi-dialogs/fi-dialogs-close-reason';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

@Component({
    selector: 'fi-customer-billing-invoice-create-dialog',
    templateUrl: './customer-billing-invoice-create-dialog.component.html',
    styleUrls: ['./customer-billing-invoice-create-dialog.component.scss'],
    standalone: false,
})
export class CustomerBillingInvoiceCreateDialogComponent
    extends FiDialogsContentBase<CustomerBillingInvoiceModel, boolean>
    implements OnInit
{
    private invoiceService: InvoiceService;
    private fiLoadingService: LoadingService;
    private fiDialogsService: FiDialogsService;

    ngOnInit() {
        this.invoiceService = this.injector.get(InvoiceService);
        this.fiLoadingService = this.injector.get(LoadingService);
        this.fiDialogsService = this.injector.get(FiDialogsService);
    }

    editInvoice() {
        this.fiDialogsService
            .custom({
                hideHeader: true,
                hideFooter: true,
                contentComponentRef: CustomerBillingInvoiceEditDialogComponent,
                contentComponentData: this.data,
                config: {
                    panelClass: 'fi-customer-billing-invoice-panel',
                    minWidth: '70%',
                    maxWidth: '70%',
                    minHeight: '90%',
                    maxHeight: '90%',
                },
            })
            .onYesButtonClick(() => {
                this.dialogRef.close({
                    value: true,
                    reason: FiDialogCloseReason.YesButton,
                });
            });
    }

    saveInvoice() {
        const promise = this.invoiceService.SaveInvoice(this.data);
        this.fiLoadingService.trackPromise(promise);
        promise.then((Id) => {
            this.data.Id = Id;
            this.dialogRef.close({
                value: true,
                reason: FiDialogCloseReason.YesButton,
            });
        });
    }
}
